'use client'

import { useEffect } from 'react'
import { getCustomerIoAnalytics } from '@/MainLayout/CustomerIoCdp'

/**
 * Customer.io CDP loader (matches current site behavior: not CookieYes-gated).
 * This is a tiny bootstrap so CIO is available even before the first tracking call.
 */
export function CustomerIoCdpInit() {
  useEffect(() => {
    void getCustomerIoAnalytics()
  }, [])

  return null
}


